// @flow
import { ArchitectsActionTypes } from './actionTypes';
import type { FluxStandardAction } from 'modules/helper';
import type { GalleryImageType } from 'types/common';
import type { ProjectOverlayDescriptionData } from 'types/project';

export type ArchitectsState = {
  gallery: Array<GalleryImageType> | null,
  projectOverlayData: Array<ProjectOverlayDescriptionData> | null,
  loading: {
    gallery: boolean,
    projectOverlayData: boolean,
  },
  error: {
    gallery: string | null,
    projectOverlayData: string | null,
  },
};

const initialState: ArchitectsState = {
  gallery: null,
  projectOverlayData: null,
  loading: {
    gallery: false,
    projectOverlayData: false,
  },
  error: {
    gallery: false,
    projectOverlayData: false,
  },
};

export const ArchitectsReducer = (
  state: ArchitectsState = initialState,
  action: FluxStandardAction
) => {
  const { type, payload, error } = action;
  switch (type) {
    // Gallery
    case ArchitectsActionTypes.GALLERY.FETCH:
      return {
        ...state,
        loading: { ...state.loading, gallery: true },
        error: { ...state.error, gallery: null },
      };
    case ArchitectsActionTypes.GALLERY.SUCCESS:
      return {
        ...state,
        gallery: payload,
        loading: { ...state.loading, gallery: false },
      };
    case ArchitectsActionTypes.GALLERY.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, gallery: false },
        error: { ...state.error, gallery: error },
      };
    // PROJECT OVERLAY DESCRIPTION
    case ArchitectsActionTypes.PROJECT_OVERLAY.FETCH:
      return {
        ...state,
        loading: { ...state.loading, projectOverlayData: true },
        error: { ...state.error, projectOverlayData: null },
      };
    case ArchitectsActionTypes.PROJECT_OVERLAY.SUCCESS:
      return {
        ...state,
        projectOverlayData: payload,
        loading: { ...state.loading, projectOverlayData: false },
      };
    case ArchitectsActionTypes.PROJECT_OVERLAY.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, projectOverlayData: false },
        error: { ...state.error, projectOverlayData: error },
      };

    default:
      return state;
  }
};
